module.exports = __webpack_public_path__ + "static/media/image-7.2074498b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Apteligent/image-7.png
// module id = 257
// module chunks = 0